<div class="ui-modal">
  <div class="header flex-row space-between-center">
    {{ 'PERSONS.CONFIRM_RECOGNITION.TITLE' | translate }}
    <span class="ui-icon-close c-p" (click)="closeDialog()"></span>
  </div>
  <div class="body flex-col start-start flex gap-16 dialog-content narrower-input">
    <div class="w-100 flex-col center-center gap-4">
      <span class="recognition-title">{{ 'PERSONS.CONFIRM_RECOGNITION.REVIEW_TITLE' | translate }}</span>
      <span class="recognition-description">{{ 'PERSONS.CONFIRM_RECOGNITION.REVIEW_DESCRIPTION' | translate }}</span>
    </div>

    @if (isLoadingSuggestions()) {
      <div class="recognition-loading w-100">
        <ui-preloader [color]="preloaderColor.blue"></ui-preloader>
      </div>
    } @else {
      <div class="w-100 flex-row space-between-center gap-16 recognition-sections">
        <div class="recognition-container">
          <p class="recognition-person-name">{{ 'PERSONS.CONFIRM_RECOGNITION.PERSON_OF_INTEREST' | translate }}</p>
          @if (positiveSuggestions().length > 0) {
            <div class="recognition-grid">
              @for (person of positiveSuggestions(); track person.trackerId; let index = $index) {
                <button
                  type="button"
                  class="recognition-image positive"
                  [class.image-visible]="isSuggestionVisible(person.trackerId)"
                  [matTooltip]="'PERSONS.CONFIRM_RECOGNITION.TOOLTIPS.PERSON_OF_INTEREST_DETECTED' | translate"
                  matTooltipClass="sidebar-tooltip"
                  (click)="selectSuggestion(person)"
                >
                  <img
                    [appAuthSrc]="getImagePath(person)"
                    [appAuthSrcFallback]="getImagePath(person, false)"
                    [alt]="('PERSONS.CONFIRM_RECOGNITION.IMAGE_ALT' | translate) + ' ' + (index + 1)"
                    (authLoaded)="onSuggestionImageLoaded(person.trackerId)"
                    (authError)="onSuggestionImageError(person.trackerId)"
                  >
                  <span class="image-overlay">
                    <span class="image-status correct">
                      <span class="ui-icon-checkmark"></span>
                    </span>
                  </span>
                </button>
              }
            </div>
          } @else {
            <div class="recognition-container-empty">
              <ui-no-data
                [description]="'PERSONS.CONFIRM_RECOGNITION.NO_SUGGESTIONS' | translate"
                imgSrc="assets/people-no-plus.svg"
              ></ui-no-data>
            </div>
          }
        </div>
        <div class="recognition-container">
          <p class="recognition-person-name">{{ 'PERSONS.CONFIRM_RECOGNITION.NOT_PERSON_OF_INTEREST' | translate }}</p>
          @if (selectedSuggestions().length > 0) {
            <div class="recognition-grid">
              @for (person of selectedSuggestions(); track person.trackerId; let index = $index) {
                <button
                  type="button"
                  class="recognition-image negative"
                  [class.image-visible]="isSuggestionVisible(person.trackerId)"
                  [matTooltip]="'PERSONS.CONFIRM_RECOGNITION.TOOLTIPS.DIFFERENT_PERSON_DETECTED' | translate"
                  matTooltipClass="sidebar-tooltip"
                  (click)="removeSuggestion(person)"
                >
                  <img
                    [appAuthSrc]="getImagePath(person)"
                    [appAuthSrcFallback]="getImagePath(person, false)"
                    [alt]="('PERSONS.CONFIRM_RECOGNITION.SELECTED_IMAGE_ALT' | translate) + ' ' + (index + 1)"
                  >
                  <span class="image-overlay">
                    <span class="image-status incorrect">
                      <span class="ui-icon-close"></span>
                    </span>
                  </span>
                </button>
              }
            </div>
          } @else {
            <div class="recognition-container-empty">
              <ui-no-data
                [description]="'PERSONS.CONFIRM_RECOGNITION.EMPTY_SELECTION' | translate"
                imgSrc="assets/people-no-plus.svg"
              ></ui-no-data>
            </div>
          }
        </div>
      </div>
    }
  </div>
  <div class="footer flex-row end-center gap-8">
    <span
      class="confirm-button-tooltip"
      [matTooltip]="'PERSONS.CONFIRM_RECOGNITION.TOOLTIPS.CONFIRM_DISABLED' | translate"
      matTooltipClass="sidebar-tooltip"
      [matTooltipDisabled]="canConfirm()"
    >
      <ui-button
        type="primary"
        [text]="'COMMON.CONFIRM' | translate"
        [disabled]="!canConfirm()"
        (clickAction)="confirmRecognition()"
      ></ui-button>
    </span>
  </div>
</div>
